import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { HeroReport } from './hero-report.model';
import { possibleIdentificationKeys } from '../../utilities/possibleIdentification';

interface FetchHeroReportsResponse {
  data: {
    heroReports: HeroReport[];
  };
}

interface CreateOrUpdateHeroReportResponse {
  data: {
    heroReport: HeroReport;
  };
}

@Injectable({
  providedIn: 'root'
})

export class HeroReportService {

  constructor(private apiService: ApiService) {}

  async fetch(filters = {}): Promise<HeroReport[]> {
    try {
      const response = await this.apiService.post<any>('/hero-report/enhanced', filters);
      return response.data?.heroReports.map((raw) => ({
        ...raw,
        possibleIdentification: possibleIdentificationKeys(raw.possibleIdentification),
      })) || [];
    } catch (error) {
      throw error;
    }
  }

  async fetchById(id: string): Promise<HeroReport> {
    try {
      const response = await this.apiService.get<any>(`/hero-report/enhanced/${id}`);
      const raw = response.data?.heroReport;
      return raw ? { ...raw, possibleIdentification: possibleIdentificationKeys(raw.possibleIdentification) } : {} as HeroReport;
    } catch (error) {
      throw error;
    }
  }

  async create(heroReport: HeroReport): Promise<HeroReport> {
    const payload = {
      ...heroReport,
      possibleIdentification: JSON.stringify(possibleIdentificationKeys(heroReport.possibleIdentification)),
    };

    try {
      const response = await this.apiService.post<CreateOrUpdateHeroReportResponse>('/hero-report', payload);
      return response.data?.heroReport;
    } catch (error) {
      throw error;
    }
  }

  async update(heroReport: HeroReport): Promise<HeroReport> {
    const payload = {
      ...heroReport,
      possibleIdentification: JSON.stringify(possibleIdentificationKeys(heroReport.possibleIdentification)),
    };

    try {
      const response = await this.apiService.put<CreateOrUpdateHeroReportResponse>(`/hero-report/${heroReport.id}`, payload);
      return response.data?.heroReport;
    } catch (error) {
      throw error;
    }
  }

  async delete(id: string): Promise<void> {
    try {
      await this.apiService.delete(`/hero-report/${id}`);
    } catch (error) {
      throw error;
    }
  }
}
